var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "ivu-list-item", class: _vm.classes },
    [
      _vm.itemLayout === "vertical" && _vm.$slots.extra
        ? [
            _c(
              "div",
              { staticClass: "ivu-list-item-main" },
              [
                _vm._t("default"),
                _vm._v(" "),
                _vm.$slots.action
                  ? _c(
                      "ul",
                      { staticClass: "ivu-list-item-action" },
                      [_vm._t("action")],
                      2
                    )
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ivu-list-item-extra" },
              [_vm._t("extra")],
              2
            )
          ]
        : [
            _vm._t("default"),
            _vm._v(" "),
            _vm.$slots.action
              ? _c(
                  "ul",
                  { staticClass: "ivu-list-item-action" },
                  [_vm._t("action")],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ivu-list-item-extra" },
              [_vm._t("extra")],
              2
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1dfadb6a", { render: render, staticRenderFns: staticRenderFns })
  }
}